import { useState } from "react";
import type { WizardMissingData } from "../../../../../utils/backend-types";
import { MarkDoneActionButton } from "../../../components/MarkDoneActionButton";
import { MissingDataActionButton } from "../../../components/MissingDataActionButton";
import { AssignmentType } from "../../OnboardingWizard.constants";
import "./RegulatoryDataAssignment.scss";

export type RegulatoryDataAssignmentProps = {
  missingData: Array<WizardMissingData>;
  done: boolean;
  isDisabled: boolean;
  updateSiteWizard: (type: AssignmentType) => Promise<void>;
};

function RegulatoryDataAssignment({
  missingData,
  done,
  isDisabled,
  updateSiteWizard
}: RegulatoryDataAssignmentProps) {
  const [isSpinning, setIsSpinning] = useState(false);
  const hasMissingData = missingData && missingData.length > 0;

  function onClickSubmit() {
    setIsSpinning(true);
    updateSiteWizard(AssignmentType.Regulatory).then(() => {
      setIsSpinning(false);
    });
  }

  function getComponentByStep() {
    if (hasMissingData && !done) {
      return (
        <MissingDataActionButton
          disabled={isDisabled}
          mt="xs"
          route="regulatorischeDaten"
        />
      );
    } else if (!done) {
      return (
        <MarkDoneActionButton
          disabled={isDisabled}
          loading={isSpinning}
          onClick={() => onClickSubmit()}
        />
      );
    }
  }
  return <div className="RegulatoryDataAssignment">{getComponentByStep()}</div>;
}

export { RegulatoryDataAssignment };
